import { tableQueries } from 'app/table-queries';
import { MRT_ColumnDef, MRT_ColumnFiltersState, MRT_SortingState } from 'material-react-table';
import { store } from 'store/index';
import { TableQueryIdentifier } from 'types/table-settings';

type FilterSelectOptions = {
    [key: string]: { value: string; label: string }[] | undefined;
};

export const pluralToSingular: Record<TableQueryIdentifier, string> = {
    websites: 'website',
    companies: 'company',
    terminals: 'terminal',
    companyOwners: 'company-owner',
    endUsers: 'end-user',
    places: 'place',
    products: 'product',
    productCategories: 'productCategory',
    orders: 'order',
    nestedProducts: 'nestedProduct',
    nestedProductsCategories: 'nestedProductCategory',
    promotions: 'promotion',
};

export const configureTableColumns = <T extends { [key: string]: string }>(
    columns: MRT_ColumnDef<T>[],
    filterSelectOptions: FilterSelectOptions,
): MRT_ColumnDef<T>[] => {
    return columns.map((column) => {
        if (column.filterVariant === 'autocomplete' && column.accessorKey) {
            const key = column.accessorKey as keyof FilterSelectOptions;
            return {
                ...column,
                filterSelectOptions: filterSelectOptions[key] || [],
            };
        }
        return column;
    });
};

export const formatColumnsFilters = (filters: MRT_ColumnFiltersState) => {
    return filters.reduce((acc: Record<string, string | number | boolean>, filter) => {
        acc[filter.id] = filter.value as string | number | boolean;
        return acc;
    }, {});
};

export const formatColumnsSorting = (sorting: MRT_SortingState) => {
    return sorting.reduce((acc: Record<string, string | number | boolean>, sort) => {
        acc[sort.id] = sort.desc ? 'desc' : 'asc';
        return acc;
    }, {});
};

export const getQueryFunction = (queryIdentifier: TableQueryIdentifier) => {
    const queryFunctions = tableQueries()[queryIdentifier];
    if (!queryFunctions) {
        throw new Error(`Query identifier "${queryIdentifier}" does not exist in tableQueries.`);
    }

    const { fetchQuery } = queryFunctions;

    if (!fetchQuery) {
        throw new Error(`Fetch query function is missing for query identifier "${queryIdentifier}".`);
    }

    // if (!deleteMutation) {
    //     throw new Error(`Delete mutation function is missing for query identifier "${queryIdentifier}".`);
    // }

    return queryFunctions;
};

export const generateAddUrl = (queryIdentifier: TableQueryIdentifier): string => {
    const baseWorkspaceUrl = store.getState().workspace.baseWorkspaceUrl;

    const singular = pluralToSingular[queryIdentifier];
    if (!singular) {
        throw new Error(`Query identifier "${queryIdentifier}" does not exist in pluralToSingular.`);
    }
    return `${baseWorkspaceUrl}/add/${singular}`;
};

export const generateEditUrl = (queryIdentifier: TableQueryIdentifier, id: string, placeId?: string): string => {
    const baseWorkspaceUrl = store.getState().workspace.baseWorkspaceUrl;

    const singular = pluralToSingular[queryIdentifier];
    if (!singular) {
        throw new Error(`Query identifier "${queryIdentifier}" does not exist in pluralToSingular.`);
    }

    if (placeId) {
        return `${baseWorkspaceUrl}/${singular}/${placeId}/edit/${id}`;
    }
    return `${baseWorkspaceUrl}/${singular}/${id}`;
};

export const caseInsensitiveIncludes = (row, columnId, filterValue) => {
    const cellValue = String(row.getValue(columnId) ?? '');
    return cellValue.toLowerCase().includes(String(filterValue).toLowerCase());
};
